<template>
  <div class="login-page-container">
    <section class="login-page card">
      <h1 class="login-page__headline">{{ $t('myPage.auth.title') }}</h1>
      <LogIn routeToPage="UserInfo" />
      <div class="login-page__or-container">
        <span class="login-page__or">{{ $t('common.actions.or') }}</span>
      </div>
      <div class="login-page__main-foot">
        <router-link
          class="button button--medium button--secondary"
          to="/sign-up"
        >
          {{ $t('myPage.auth.createAccount') }}
        </router-link>
        <router-link
          class="login-page__password"
          to="/reset-password"
        >
          {{ $t('myPage.auth.forgotPassword') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useI18n } from 'vue-i18n'
  import LogIn from '@/components/MyPage/LogIn/LogIn.vue'

  export default defineComponent({
    name: 'LoginPage',
    components: {
      LogIn,
    },
    setup() {
      const { t } = useI18n()
      return { t }
    }
  })
</script>

<style lang="scss" scoped>
  .login-page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    margin-left: 16px;
    padding: rem(16) 16px;
  }

  .login-page {
    padding: rem(16) 16px;
    margin: rem(16) 16px;
    width: 100%;
    color: $clr-primary;

    @media screen and (min-width: $breakpoint-xs) {
      width: 100%;
      max-width: 543px;
      padding: rem(30) 30px;
    }

    &__headline {
      @include headline-medium;
      margin-top: 0;
      text-align: left;
    }

    &__or-container {
      display: flex;
      align-items: center;
      text-align: center;
      margin: rem(24) 0;
      position: relative;

      &::before,
      &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid $clr-primary-100;
        margin: 0 16px;
      }
    }

    &__or {
      @include body-large;
      background-color: $clr-white;
      padding: 0 16px;
      z-index: 1;
    }

    &__main-foot {
      display: flex;
      flex-direction: column;
      gap: 16px;

      a:last-child {
        text-align: left;
      }
    }

    &__password {
      color: $clr-support-two-900;
    }
  }
</style>
